<p-card class="w-64 h-50 max-w-full flex flex-col animate-fadein">
    <!-- Card Header -->
    <ng-template #header>
        <div class="flex items-center justify-between w-full p-2">
            <!-- Integration Logo -->
            <img
                class="w-8 h-auto"
                [src]="viewModel().imageLogoUrl"
                alt="Shop-Logo"
                title="Shop-Logo"
            />

            <!-- Toggle Switch -->
            <div class="ml-auto">
                <p-toggleswitch
                    [(ngModel)]="isActive"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="onToggleIntegration($event)"
                    [disabled]="!viewModel().entityId"
                />
            </div>
        </div>
        <!-- Separator -->
        <hr class="border-t border-gray-300" />
        <!-- Identifier with External Link Icon -->
        <div class="flex items-center justify-center space-x-2 text-center font-bold text-base">
            <span>{{
                viewModel().productShopIntegrationLink.integration.identifier | truncate: 25 : '...'
            }}</span>

            <!-- External Link Icon (Only if externalLink exists) -->
            <a
                *ngIf="viewModel().productShopIntegrationLink.externalLink"
                [href]="viewModel().productShopIntegrationLink.externalLink"
                target="_blank"
                class="ml-1 text-blue-500 hover:text-blue-700"
                [title]="viewModel().productShopIntegrationLink.externalLink"
            >
                <i class="fa fa-external-link-alt"></i>
            </a>
        </div>
    </ng-template>

    <!-- Card Body (FORCED SAME HEIGHT) -->
    <div class="p-2 flex-grow flex flex-col justify-between">
        <div class="flex flex-col space-y-2 min-h-12">
            <!-- Show Last Sync Info if available -->
            <div
                class="flex items-center space-x-2"
                *ngIf="viewModel().productShopIntegrationLink.lastSyncDate"
            >
                <i class="fa fa-clock"></i>
                <span class="text-sm">{{
                    viewModel().productShopIntegrationLink.lastSyncDate | localeDate: 'medium'
                }}</span>
            </div>
            <div
                class="flex items-center space-x-2"
                *ngIf="viewModel().productShopIntegrationLink.lastSyncMessage"
            >
                <i class="fa fa-refresh"></i>
                <span
                    class="text-sm"
                    [pTooltip]="viewModel().productShopIntegrationLink.lastSyncMessage"
                    >{{
                        viewModel().productShopIntegrationLink.lastSyncMessage
                            | truncate: 30 : '...'
                    }}</span
                >
            </div>

            <!-- Show Default Message if NEVER synced -->
            <div
                class="flex items-center justify-center text-gray-500 text-sm italic mt-2"
                *ngIf="!viewModel().productShopIntegrationLink.lastSyncDate"
            >
                {{ 'integration.never-synced' | translate }}
            </div>
        </div>
    </div>

    <!-- Card Footer (FORCING FULL WIDTH BUTTON) -->
    <ng-template #footer>
        <div class="w-full flex justify-center">
            <p-button
                [loading]="viewModel().productShopIntegrationLink?.isLoading"
                [id]="viewModel().productShopIntegrationLink.integration.id"
                loadingIcon="fa fa-spinner"
                [disabled]="!entityId() || !isActive()"
                [raised]="true"
                icon="fa fa-play"
                class="w-full block"
                styleClass="w-full"
                [label]="'integration.synchronize' | translate"
                [ariaLabel]="'integration.synchronize' | translate"
                (onClick)="onSyncIntegration(viewModel().productShopIntegrationLink)"
            />
        </div>
    </ng-template>
</p-card>
